var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cert-badge",class:_vm.statusClass,attrs:{"title":_vm.label}},[_c('i',{class:_vm.iconClass}),_vm._v(" "),(!_vm.$screen.mobile)?_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20425d67","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/stations/station/Certification/CertificationStatusBadge.vue
// module id = null
// module chunks = 